import { Box, styled, lighten } from '@mui/material';

export const StyledDurationBox = styled(Box)<{
  error?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
  readOnly?: boolean;
}>(({ theme, error, disabled, size, readOnly = false }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${error ? theme.palette.error.main : '#D0D5DD'}`,
  borderRadius: '8px',
  padding: size === 'medium' ? '12px' : '7px',
  transition: 'all 0.2s ease-in-out',
  width: 'fit-content',
  backgroundColor: disabled ? '#F2F4F7' : '#fff',
  // Need to enable pointer events for the tooltip to work
  pointerEvents: readOnly ? 'auto' : disabled ? 'none' : 'auto',
  '&:focus-within': {
    boxShadow: error
      ? '0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(240, 68, 56, 0.24)'
      : `0 0 0 1px ${lighten(theme.palette.primary.main, 0.4)}, 0 0 0 4px ${lighten(theme.palette.primary.main, 0.8)}`,
  },
  // Spinner hiding (Chrome, Safari, Edge)
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
}));
